/** Seletor de idioma (português, espanhol, inglês). Logado: salva na conta e recarrega; anônimo: só neste navegador
 * (e vira a preferência da conta no próximo login). */
import { useState } from "react";
import { api } from "../api/client";
import { applyLocale, LOCALE, LOCALES, markPendingLocale, t, type Locale } from "../i18n";

export function LanguageSwitcher({ loggedIn, compact = false }: { loggedIn: boolean; compact?: boolean }) {
  const [busy, setBusy] = useState(false);
  async function change(code: Locale) {
    if (code === LOCALE) return;
    setBusy(true);
    if (loggedIn) {
      try {
        await api.patch("/auth/me", { locale: code });
      } catch {
        /* sem rede: a escolha vale neste navegador e é enviada no próximo login */
        markPendingLocale();
      }
    } else {
      markPendingLocale();
    }
    applyLocale(code);
  }
  return (
    <label className={`lang-switch ${compact ? "compact" : ""}`}>
      <span className={compact ? "visually-hidden" : "lang-label"}>{t("Idioma")}</span>
      <select
        className="select select-sm"
        value={LOCALE}
        disabled={busy}
        onChange={(e) => void change(e.target.value as Locale)}
        aria-label={t("Idioma")}
      >
        {LOCALES.map((l) => (
          <option key={l.code} value={l.code} lang={l.code}>
            {compact ? l.short : l.label}
          </option>
        ))}
      </select>
    </label>
  );
}
